import { Component, EventEmitter, OnInit, Output, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { forkJoin, Observable } from 'rxjs';
import { DialogService } from '../../../_services/dialog.service';
import { FundraisingReportService } from '../../../_services/fundraising/fundraisingReport.service';
import { PledgePerWinGameConfirmModalComponent } from './ppw-game-confirm-modal.component';
import { PledgePerWin } from '../../../_models/fundraising/ppw/PledgePerWin';
import { PledgePerWinService } from '../../../_services/fundraising/pledgePerWin.service';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { Game } from '../../../_models/fundraising/ppw/Game';

@Component({
    templateUrl: './ppw-game-completion-modal.component.html',
    styleUrls: ['./ppw-game-completion-modal.component.css']
  })

export class PledgePerWinGameCompletionModalComponent implements OnInit{

    public ppws: PledgePerWin[] = [];

    // Passed as initial state by game management component, we're just viewing the game
    public gameId: number;
    public game: Game;

    // Passed as initial state by season management component, we already know the season
    public pledgePerWinId: number;
    public statistic: string;

    public form: FormGroup;

    private confirmBsModalRef: BsModalRef;

    private hasValidationErrors: boolean;

    @Output() charged = new EventEmitter;

    constructor(
        private ppwService: PledgePerWinService,
        private fb: FormBuilder,
        private dialogService: DialogService,
        private viewRef: ViewContainerRef,
        private modalService: BsModalService,
        private bsModalRef: BsModalRef,
        private datePipe: DatePipe,
        private spinner: NgxSpinnerService
    ){}

    ngOnInit(){
        if (!this.ppws || this.ppws.length < 1){
            this.spinner.show();
            this.ppwService.getAll()
                .subscribe(data => {
                    this.spinner.hide();

                    this.ppws = data.pledgePerWins.filter(ppw => ppw.event.status === 2);

                    this.gameId = this.game?.pledgePerWinGameId;
                    this.pledgePerWinId = this.game?.pledgePerWinId || this.pledgePerWinId;
                    this.createForm(this.game);
                }, error => {
                    this.close();
                    this.dialogService.alert("Uh oh!", `Unable to load PPW Campaigns: ${error.error}`, this.viewRef);
                });
        } else {
            this.ppws = this.ppws.filter(ppw => ppw.event.status === 2);
            this.createForm(this.game);
        }
    }

    createForm(game: Game){
        const dateFormat = 'yyyy-MM-ddTHH:mm';

        this.form = this.fb.group({
            pledgePerWinId: [this.pledgePerWinId || 0, [Validators.required, Validators.min(1)]],
            name: [game?.name || "", [Validators.required, Validators.maxLength(30)]],
            dateCompleted: [game?.dateCompleted ? this.datePipe.transform(game.dateCompleted, dateFormat) 
                                                : this.datePipe.transform(new Date(Date.now()), dateFormat), Validators.required],
            message: [game?.message || "", [Validators.required, Validators.maxLength(150)]],
            chargeCount: [game?.chargeCount || 0, [Validators.required, Validators.min(1)]]
        });

        if (this.pledgePerWinId){
            const ppw = this.ppws.find(p => p.pledgePerWinId === this.pledgePerWinId);
            this.statistic = ppw?.statistic;
        }

        if (game){
            this.form.disable();
        }
    }

    onChangeCampaign(event: any){
        const ppw = this.ppws.find(p => p.pledgePerWinId === +event.target.value);
        this.statistic = ppw?.statistic;
    }

    openConfirmDialog(){
        this.hasValidationErrors = !this.form.valid;
        const invalid = [];
        const controls = this.form.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        if (this.hasValidationErrors) {
            this.form.markAllAsTouched();
            this.form.markAsDirty();
            return;
        }

        this.spinner.show();
        this.ppwService.getChargeInformation(this.form.controls.pledgePerWinId.value)
            .subscribe(info => {
                this.spinner.hide();

                const modalConfig = {
                    backdrop: true,
                    ignoreBackdropClick: true
                };
                
        
                const initialState = {
                    numberOfSubscribers: info.totalSubscribers, // Acquired through some api call
                    totalChargeAmount: (info.totalChargeAmount * this.form.controls.chargeCount.value) / 100, // Acquired through some api call
                    parentModalRef: this.bsModalRef
                };
                
                this.close();
                this.confirmBsModalRef = this.modalService
                    .show(
                        PledgePerWinGameConfirmModalComponent,
                        Object.assign({}, modalConfig, { class: 'modal-md', initialState }));
                
                this.confirmBsModalRef.content.submitted
                    .subscribe(res => {
                        if (res){
                            const newGame = new Game(this.form.getRawValue());
                            this.spinner.show();
                            this.ppwService.initiateChargeProcess(newGame)
                                .subscribe(
                                    _ => {
            
                                        this.spinner.hide();
                                        const seasonName = this.ppws.find(p => p.pledgePerWinId === +this.form.controls.pledgePerWinId.value).event.name;
                                        this.dialogService.alert("Success!", `The subscribers to ${seasonName} have been charged.`, this.viewRef)
                                            .then(_ => {
                                                this.charged.emit();
                                            });
                                    },
                                    error => {

                                        this.spinner.hide();
                                        this.dialogService.alert("Uh oh!", `Something went wrong when trying to charge your subscribers: ${error.error}`, this.viewRef);
                                    }
                                )
                        }
                });
            });
    }
      
    close() {
        this.bsModalRef.hide();
    }
}